<template>
    <div class="head-menu">
        <el-space wrap size="large">
           
            <!-- 个人设置  -->
            <el-dropdown>
                    <span class="el-dropdown-link">
                        <span>{{adminName}}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item icon="el-icon-switch-button" @click="logout">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </el-space>
    </div>
</template>

<script>
    import{adminBaseInfo} from '../api/serviceApi'
    export default {
        data() {
            return {
                adminName:''
            }
        },
        methods: {
            getAdminBaseInfo(){
                let name=sessionStorage.getItem('adminName')
                if(name){
                    this.adminName=name
                }else{
                    adminBaseInfo().then(res=>{
                        if(res.code==200){
                            this.adminName=res.data.real_name
                            sessionStorage.setItem('adminName',this.adminName)
                        }else{
                            console.log(res)
                        }
                    })
                }
                
            },
            logout(){
                sessionStorage.clear()
                localStorage.clear()
                window.location.href="http://admin.bg.ciprun.com/admin"
            }
        },
        created() {
            this.getAdminBaseInfo();
        },
    }
</script>

<style lang="less">
    .head-menu {
        text-align: right;
        cursor: pointer;
        margin-right: 40px;
        .el-badge__content.is-fixed.is-dot {
            top: 15px;
        }
    }
</style>